import { render, staticRenderFns } from "./Rubros.vue?vue&type=template&id=d77928ea&"
import script from "./Rubros.vue?vue&type=script&lang=js&"
export * from "./Rubros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports